/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'favorite-outline': {
    width: 32,
    height: 30,
    viewBox: '0 0 32 30',
    data: '<path pid="0" d="M16 0l4.5 10.43 11.5.986-8.692 7.471L25.923 30 16 24.083 6.077 30 8.73 18.887 0 11.416l11.5-.986L16 0zm3.137 12.32L16 5.05l-3.137 7.271-7.935.68 6.032 5.163-1.837 7.692 6.877-4.1 6.895 4.111-1.812-7.703L27.086 13l-7.949-.68z" _fill="#000" fill-rule="nonzero"/>'
  }
})
